import { ArrowLeftIcon } from '@radix-ui/react-icons'
import { Drop } from './icons/Drop'
import { Lightning } from './icons/Lightning'
import { Fuel } from './icons'
import { CarImage } from './CarImage'

export function CarDetailsOverview({
  car,
  carImageQuery,
  budgetNo,
  vehicleType,
}: {
  car: any
  carImageQuery?: any
  budgetNo?: string
  vehicleType?: string
}) {
  return (
    <div className="w-full">
      <div className="flex gap-4 w-full">
        {/*  <a href="/cars" className="md:block hidden z-[4]">
          <ArrowLeftIcon width={'20px'} height={'30px'} />
        </a> */}
        <div className="flex flex-col gap-2">
          <span className="text-2xl font-medium">
            {car.make} {car.model}
          </span>
          <span>{car.engine}</span>
          <div className="flex gap-4">
            <span className="bg-blue-100 border-old-primary text-old-primary border-[1px] py-1 px-4 rounded-sm">
              {car.registrationNumber ? car.registrationNumber : car?.budgetNo}
            </span>
            {car?.fuel && (
              <div className="flex items-center gap-2 bg-gray-100 capitalize border-gray-100 border-[1px] py-1 px-4 rounded-sm">
                <span className=" text-old-primary">
                  <CarEngineSymbol engineType={car.fuel} />
                </span>
                {car.fuel}
              </div>
            )}
            <span className="bg-gray-100 border-gray-100 border-[1px] py-1 px-4 rounded-sm">{car.year}</span>
          </div>
        </div>
      </div>
      <CarImage
        shouldAnimate={false}
        carImageQuery={carImageQuery}
        budgetNo={car.budgetNo}
        vehicleType={car.vehicleType}
      />{' '}
    </div>
  )
}

export function CarEngineSymbol({ engineType }: { engineType: string }) {
  const engine = engineType.toLowerCase()
  if (engine.includes('hybrid')) {
    return <Fuel />
  }

  if (engine.includes('elektrisk')) {
    return <Lightning />
  }

  return <Fuel />
}
